/* ------------ TABLE CONFIGURATION ------------ */

export interface QuestionnaireWPAI {
  position: number;
  question: string;
}

export const Q_WPAI: QuestionnaireWPAI[] = [
  {
    // tslint:disable-next-line:max-line-length
    position: 1, question: 'Attualmente è impiegato/a (percepisce uno stipendio)?'
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 2, question: 'Negli ultimi sette giorni, per quante ore si è assentato/a dal lavoro a causa di problemi inerenti alla malattia infiammatoria cronica intestinale? Includa le ore delle giornate di malattia, le volte in cui si è recato/a al lavoro più tardi o ha lasciato il lavoro in anticipo, ecc. a causa della malattia infiammatoria cronica intestinale. Non includa le ore perse per partecipare a questo studio.',
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 3, question: 'Negli ultimi sette giorni, quante ore si è assentato/a dal lavoro per altri motivi, come vacanze, giorni festivi, permessi per partecipare a questo studio?',
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 4, question: 'Negli ultimi sette giorni, quante ore effettive di lavoro ha svolto? (Se la risposta è "0", passi alla domanda 6)',
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 5, question: 'Negli ultimi sette giorni, in quale misura la malattia infiammatoria cronica intestinale ha inciso sulla sua produttività durante il lavoro? Pensi ai giorni in cui ha dovuto limitare la mole o il tipo di lavoro da svolgere, ai giorni in cui ha fatto meno di quanto avrebbe voluto, o ai giorni in cui non è stato/a in grado di svolgere il lavoro con la consueta attenzione.'
},
  {
    // tslint:disable-next-line:max-line-length
    position: 6, question: 'Negli ultimi sette giorni, in quale misura la malattia infiammatoria cronica intestinale ha inciso sulla sua capacità di svolgere le normali attività giornaliere, escluso il lavoro? Con "normali attivita" si intendono le consuete attività da lei svolte, come: lavori domestici, la spesa, la cura dei bambini, l\'esercizio fisico, lo studio, ecc. Pensi ai giorni in cui ha dovuto limitare la mole o il tipo di attività, o ai giorni in cui ha fatto meno di quanto avrebbe voluto.'
  },
];


export class WpaiResults {
  patientSSN: string;
  doctorID: string;
  results: string[];

  constructor(doctorID: string, patientSSN: string, results: string[]) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
  }

}
